import './style.scss';

import React from 'react';

const Toggle = (props) => {
  const selectedValue = props.value || props.options[0].value;
  const className = 'toggle' + (props.className ? ` ${props.className}` : '');

  return (
    <div className={className}>
      {
        props.options.map(option => {
          const id = [props.name, option.value].join('-')
          const labelClass = 'toggle__label' +
            (option.value === selectedValue ? ' toggle__label--selected' : '');

          return (
            <label className={labelClass} htmlFor={id} key={id}>
              <input
                type="radio"
                className="toggle__input"
                id={id}
                name={props.name}
                value={option.value}
                onChange={() => props.onChange(option.value)}
              />
              {option.icon && <img className="toggle__icon" src={option.icon} />}
              <span>{option.label}</span>
            </label>
          )
        })
      }
    </div>
  )
}

export default Toggle;



// WEBPACK FOOTER //
// ./shared/components/ui/toggle/index.js